(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fdf-performance-assessment"] && !Shopify.designMode) return;
  try {
    
  class FdfAssessment extends HTMLElement {
    connectedCallback(){this.root=this;this.copy=JSON.parse(this.querySelector('[data-fdf-copy]').textContent);this.answers={};this.index=0;this.questions=this.copy.questions;this.bind();this.restore()}
    bind(){this.querySelector('[data-fdf-start]').addEventListener('click',()=>this.start());this.querySelector('[data-fdf-question-form]').addEventListener('submit',e=>{e.preventDefault();this.next()});this.querySelector('[data-fdf-back]').addEventListener('click',()=>this.back());this.querySelectorAll('[data-fdf-restart]').forEach(x=>x.addEventListener('click',()=>this.restart()));this.querySelector('.fdf-assessment__customer-form').addEventListener('submit',e=>this.submitLead(e))}
    start(){this.show('quiz');this.renderQuestion()}
    show(name){['intro','quiz','email','result','safety'].forEach(k=>{const el=this.querySelector(`[data-fdf-${k}]`);if(el)el.hidden=k!==name});this.scrollIntoView({behavior:'smooth',block:'start'})}
    optionsFor(q){return q.dynamic==='mission'?(this.copy.missionOptions[this.answers.q2]||[]):q.options}
    renderQuestion(){const q=this.questions[this.index],opts=this.optionsFor(q),chosen=this.answers[q.id];this.querySelector('[data-fdf-question]').textContent=q.text;const help=this.querySelector('[data-fdf-help]');help.textContent=q.help||'';help.hidden=!q.help;this.querySelector('[data-fdf-options]').innerHTML=opts.map(([v,l])=>`<label class="fdf-assessment__option"><input type="radio" name="answer" value="${this.escape(v)}" ${chosen===v?'checked':''}><span>${this.escape(l)}</span></label>`).join('');this.querySelector('[data-fdf-back]').hidden=this.index===0;this.querySelector('[data-fdf-next]').textContent=this.index===this.questions.length-1?this.copy.build:this.copy.next;const pct=Math.round(((this.index+1)/this.questions.length)*100);this.querySelector('[data-fdf-progress]').setAttribute('aria-valuenow',pct);this.querySelector('[data-fdf-progress-bar]').style.width=`${pct}%`;this.querySelector('[data-fdf-progress-text]').textContent=`${this.copy.step} ${this.index+1} ${this.copy.of} ${this.questions.length}`;this.querySelector('[data-fdf-question-error]').hidden=true}
    next(){const selected=this.querySelector('input[name=answer]:checked');if(!selected){this.querySelector('[data-fdf-question-error]').hidden=false;return}const q=this.questions[this.index];this.answers[q.id]=selected.value;if(q.id==='q2')delete this.answers.q3;if(q.id==='q11'&&selected.value==='urgent'){this.persist();this.show('safety');return}this.persist();if(this.index<this.questions.length-1){this.index+=1;this.renderQuestion()}else{this.result=this.evaluate();this.renderPreview();this.show('email')}}
    back(){if(this.index>0){this.index-=1;this.renderQuestion()}}
    score(){const a=this.answers;const days={d0_1:0,d2:1,d3:2,d4:3,d5plus:3},breaks={none:3,w1_2:3,w3_8:1,m2_6:1,over_6m:0},movement={urgent:0,worsening:0,stable:1,none:3},strength={none:0,learning:1,random:2,progressive:3,advanced:3},aerobic={under_10:0,m10_20:1,m20_30:2,m30_45:2,over_45:3},recovery={derailed:0,poor:1,manageable:2,good:3};return{consistency:Math.min(days[a.q5],breaks[a.q6]),movement:movement[a.q11],strength:strength[a.q8],aerobic:aerobic[a.q9],recovery:recovery[a.q12]}}
    readiness(s){if(this.answers.q11==='worsening')return'reset';const v=Object.values(s);if(v.some(x=>x===0))return'reset';if(v.some(x=>x===1))return'foundation';const c=v.filter(x=>x===3).length;if(v.every(x=>x===3)&&this.answers.q3==='maintain'&&this.answers.q8==='advanced')return'sustainment';if(v.every(x=>x>=2)&&c>=3)return['lean_strong','hybrid_endurance'].includes(this.answers.q2)?'integration':'performance';return'development'}
    constraints(readiness){const a=this.answers,c={pain_limitation:0,recovery:0,goal_conflict:0,consistency:0,strength:0,aerobic_base:0,body_composition:0,fueling:0,programming:0,repeatability:0,time_schedule:0,equipment:0},priority={pain_limitation:10,recovery:7,goal_conflict:6,consistency:5,strength:5,aerobic_base:5,body_composition:4,fueling:4,programming:4,repeatability:3,time_schedule:3,equipment:2};if(a.q5==='d0_1'||a.q6==='over_6m')c.consistency=3;else if(a.q5==='d2'||['w3_8','m2_6'].includes(a.q6))c.consistency=2;if(a.q11==='worsening')c.pain_limitation=3;else if(a.q11==='stable')c.pain_limitation=1;if(a.q12==='derailed')c.recovery=3;else if(a.q12==='poor')c.recovery=2;if(a.q8==='none')c.strength=3;else if(a.q8==='learning')c.strength=2;if(a.q9==='under_10')c.aerobic_base=3;else if(a.q9==='m10_20')c.aerobic_base=2;if(a.q10==='several_days')c.repeatability=3;else if(a.q10==='over_48')c.repeatability=2;if(a.q8==='random')c.programming=3;if(a.q18==='goals')c.goal_conflict=3;if(a.q4==='under_8'&&['reset','foundation'].includes(readiness))c.goal_conflict=Math.max(c.goal_conflict,2);if(a.q18==='time')c.time_schedule=3;if(a.q17==='bodyweight'&&['strength_muscle','fireground'].includes(a.q2))c.equipment=2;if(a.q2==='lean_strong')c.body_composition=a.q13==='unintentional'?3:a.q13==='inconsistent'?2:0;if(['strength_muscle','hybrid_endurance'].includes(a.q2))c.fueling=a.q13==='unintentional'?3:a.q13==='inconsistent'?2:0;const map={consistency:'consistency',pain:'pain_limitation',sleep:'recovery',nutrition:a.q2==='lean_strong'?'body_composition':'fueling',strength:'strength',conditioning:'aerobic_base',plan:'programming',goals:'goal_conflict',time:'time_schedule'};if(map[a.q18])c[map[a.q18]]=Math.max(c[map[a.q18]],2);return Object.entries(c).filter(x=>x[1]>0).sort((x,y)=>y[1]-x[1]||priority[y[0]]-priority[x[0]])}
    evaluate(){const s=this.score(),readiness=this.readiness(s),ranked=this.constraints(readiness),primary=ranked[0]?.[0]||'programming',mission=this.answers.q2,protect=mission==='strength_muscle'?'engine':['lean_strong','hybrid_endurance'].includes(mission)?'strength':'balanced';let resource=mission==='lean_strong'?'shred':['fireground','hybrid_endurance'].includes(mission)?'conditioning':'roadmap';if(['reset','foundation'].includes(readiness)&&primary==='consistency')resource='reset_guide';if(primary==='pain_limitation')resource='none';let offer=['reset','foundation'].includes(readiness)?'blueprint_later':'blueprint';if(primary==='pain_limitation')offer='no_offer';const frameworks={a2:'Two full-body sessions with brief easy aerobic work as tolerated.',a3:'Two full-body strength sessions plus one mission-focused session, or three integrated sessions.',a4:'Two strength sessions plus two mission-focused sessions.',a5:'Two to three strength sessions plus two to three mission sessions.',a6plus:'Approximately five primary sessions plus optional easy recovery work.'};return{readiness,mission,primary,secondary:ranked[1]?.[0]||null,protect,resource,offer,week:frameworks[this.answers.q14]}}
    renderPreview(){const r=this.result;this.submissionId=this.submissionId||Date.now();this.plan=['academy','cpat'].includes(this.answers.q3)?'academy_cpat':r.mission;const tags=['FDF-Roadmap',`Level-${r.readiness}`,`Mission-${r.mission}`,`Goal-${this.answers.q3}`,`Constraint-${r.primary}`,`Constraint2-${r.secondary||'none'}`,`Protect-${r.protect}`,`Shift-${this.answers.q16}`,`Equipment-${this.answers.q17}`,`Resource-${r.resource}`].map(x=>x.replaceAll('_','-'));tags.push(['FDF-Result-v1',this.submissionId,r.mission,r.readiness,r.primary,r.secondary||'none',r.protect,r.resource,r.offer,this.answers.q14,this.answers.q3,this.answers.q16,this.answers.q17].join(':'));tags.push(['FDF-Plan-v1',this.submissionId,this.plan].join(':'));for(let part=0;part<3;part++){tags.push(['FDF-Answers-v1',this.submissionId,part+1,...this.questions.slice(part*6,part*6+6).map(q=>this.answers[q.id])].join(':'))}this.querySelector('[data-fdf-tags]').value=tags.join(',');this.querySelector('[data-fdf-result-summary]').value=JSON.stringify({answers:this.answers,result:r,plan:this.plan});this.persist()}
    async submitLead(e){e.preventDefault();const form=e.currentTarget;if(this.submitting)return;if(!form.reportValidity())return;this.lead={firstName:form.elements['contact[first_name]'].value,email:form.elements['contact[email]'].value};this.persist();this.submitting=true;const button=form.querySelector('button[type=submit]');button.disabled=true;form.setAttribute('aria-busy','true');const error=this.querySelector('[data-fdf-email-error]');error.hidden=true;try{const response=await fetch(form.action,{method:'POST',body:new FormData(form),credentials:'same-origin'});const page=new DOMParser().parseFromString(await response.text(),'text/html');const saved=page.querySelector('[data-fdf-submit-status="success"]');if(!response.ok||!saved)throw new Error('submission_failed');sessionStorage.removeItem('fdf-'+this.id);this.show('result')}catch(x){error.hidden=false;button.disabled=false;this.submitting=false}finally{form.removeAttribute('aria-busy')}}
    renderResult(){}
    persist(){try{sessionStorage.setItem(`fdf-${this.id}`,JSON.stringify({answers:this.answers,index:this.index,submissionId:this.submissionId,lead:this.lead}))}catch(x){}}
    restore(){try{const s=JSON.parse(sessionStorage.getItem(`fdf-${this.id}`));if(s){this.answers=s.answers||{};this.index=Math.min(s.index||0,this.questions.length-1);this.submissionId=s.submissionId;this.lead=s.lead;if(this.lead){const form=this.querySelector('.fdf-assessment__customer-form');form.elements['contact[first_name]'].value=this.lead.firstName||'';form.elements['contact[email]'].value=this.lead.email||''}}const complete=this.questions.every(q=>this.answers[q.id]);const status=this.querySelector('[data-fdf-submit-status]').dataset.fdfSubmitStatus;if(complete&&status==='success'){this.result=this.evaluate();this.show('result');sessionStorage.removeItem(`fdf-${this.id}`)}else if(complete&&status==='error'){this.result=this.evaluate();this.renderPreview();this.show('email');this.querySelector('[data-fdf-email-error]').hidden=false}}catch(x){}}
    restart(){this.answers={};this.index=0;this.result=null;this.submissionId=null;this.lead=null;this.submitting=false;sessionStorage.removeItem(`fdf-${this.id}`);this.show('intro')}
    escape(v){const d=document.createElement('div');d.textContent=String(v);return d.innerHTML}
  }
  document.querySelectorAll('.fdf-assessment').forEach(el=>{if(!el.dataset.ready){el.dataset.ready='true';Object.setPrototypeOf(el,FdfAssessment.prototype);el.connectedCallback()}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdf-playbook"] && !Shopify.designMode) return;
  try {
    
function initializePlaybook(root) {
  root.querySelectorAll('[data-fdf-playbook]').forEach((page) => {
    if (page.dataset.initialized) return;
    page.dataset.initialized = 'true';
    const dialog = page.querySelector('dialog');
    page.querySelectorAll('[data-pb-open]').forEach(button => button.addEventListener('click', () => dialog.showModal()));
    page.querySelector('[data-pb-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  });
}
initializePlaybook(document);
document.addEventListener('shopify:section:load', event => initializePlaybook(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdf-shred"] && !Shopify.designMode) return;
  try {
    
function initializeShred(root) {
  root.querySelectorAll('[data-fdf-shred]').forEach((page) => {
    if (page.dataset.initialized) return;
    page.dataset.initialized = 'true';
    const dialog = page.querySelector('dialog');
    page.querySelectorAll('[data-sp-open]').forEach(button => button.addEventListener('click', () => dialog.showModal()));
    page.querySelector('[data-sp-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  });
}
initializeShred(document);
document.addEventListener('shopify:section:load', event => initializeShred(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdf-statistics"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fdf-statistics')) {
  customElements.define('fdf-statistics', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.state === 'done') return;
      this.items = Array.from(this.querySelectorAll('[data-final]')).map(node => {
        const final = node.dataset.final.trim();
        const match = final.match(/^([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);
        if (!match) return { node, final };
        const decimals = (match[1].split('.')[1] || '').length;
        return { node, final, value: Number(match[1].replace(/,/g, '')), suffix: match[2], format: new Intl.NumberFormat('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping: match[1].includes(',') }) };
      });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = () => { if (this.motion.matches) this.finish(); };
      this.motion.addEventListener('change', this.onMotion);
      if (this.motion.matches || !('IntersectionObserver' in window)) { this.finish(); return; }
      this.items.forEach(item => { if (Number.isFinite(item.value)) item.node.textContent = item.format.format(0) + item.suffix; });
      this.dataset.state = 'waiting';
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.dataset.state = 'running';
        let start;
        const tick = time => {
          if (start === undefined) start = time;
          const progress = Math.min((time - start) / 1800, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.items.forEach(item => { if (Number.isFinite(item.value)) item.node.textContent = item.format.format(item.value * eased) + item.suffix; });
          if (progress < 1) this.frame = requestAnimationFrame(tick);
          else this.finish();
        };
        this.frame = requestAnimationFrame(tick);
      }, { threshold: 0.25 });
      this.observer.observe(this);
    }
    finish() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.items.forEach(item => { item.node.textContent = item.final; });
      this.dataset.state = 'done';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.onMotion);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
